// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bpvs","col":"styles_col__15LVF"};